export const ErrorPage = () => {
  return (
    <div>
      <h2>Page not found!</h2>
    </div>
  );
};
